module.exports = __webpack_public_path__ + "img/bg.9795d450.png";